import React from 'react';
import { Grid, Typography, useTheme, Box } from '@mui/material';
import PropTypes from 'prop-types';
import moment from 'moment';
import utils from '../../utils/Utils';
import SwalToast from './SwalToast';

export const CommonTableCell = ({ value }) => {
  const displayValue = utils.isValueEmpty(value) ? '-' : value;
  return (
    <Grid item overflow="hidden" textOverflow="ellipsis">
      <Typography variant="subtitle2" noWrap title={displayValue}>
        {value}
      </Typography>
    </Grid>
  );
};

export const DateTimeCell = ({ value, format }) => {
  const dateFormat = format || 'DD/MM/YYYY, HH:mm:ss';
  const formatted = value ? moment(value).format(dateFormat) : '';
  return <CommonTableCell value={formatted} />;
};

export const StatusCell = ({ value }) => {
  const theme = useTheme();

  return (
    <Box
      width="80px"
      height="28px"
      border={
        value
          ? `1px solid ${theme.palette.other.lightGreen2}`
          : `1px solid ${theme.palette.other.lightRed2}`
      }
      borderRadius="18px"
      display="flex"
      justifyContent="center"
      backgroundColor={
        value ? theme.palette.other.lightGreen : theme.palette.other.lightRed
      }
      padding="2px 6px"
      alignItems="center"
    >
      <Box
        width="6px"
        height="6.5px"
        borderRadius="36px"
        backgroundColor={
          value
            ? theme.palette.other.lightGreen1
            : theme.palette.other.lightRed1
        }
        marginRight={value ? '6px' : '3px'}
      />
      <Typography
        variant="subtitle3"
        title={value ? 'Active' : 'Inactive'}
        color={
          value
            ? theme.palette.other.lightGreen2
            : theme.palette.other.lightRed2
        }
      >
        {value ? 'Active' : 'Inactive'}
      </Typography>
    </Box>
  );
};

StatusCell.propTypes = {
  value: PropTypes.bool.isRequired,
};

export const CopyableCell = ({ value, title = 'Copied to clipboard!' }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    SwalToast({
      icon: 'success',
      title,
    });
  };

  return (
    <Grid
      item
      overflow="hidden"
      textOverflow="ellipsis"
      onClick={handleCopy}
      style={{ cursor: 'pointer' }}
    >
      <Typography variant="subtitle2" noWrap title={value}>
        {value}
      </Typography>
    </Grid>
  );
};

CopyableCell.propTypes = {
  value: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

DateTimeCell.propTypes = {
  value: PropTypes.string.isRequired,
  format: PropTypes.string,
};

DateTimeCell.defaultProps = {
  format: 'DD/MM/YYYY, HH:mm:ss',
};

CommonTableCell.propTypes = {
  value: PropTypes.string.isRequired,
};
